<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <div class="d-md-flex align-items-center pb-2">
          <h3 class="card-title mb-0">Transaksi Bank Masuk</h3>
          <div class="ml-auto">
            <vs-button @click="inputTrans" color="success" type="filled" class="mt-4 mt-md-0">
              <i class="mdi mdi-border-color mr-1"></i> Input Transaksi
            </vs-button>
          </div>
        </div>
        <hr class="custom-hr" />
        <JqxGrid ref="myGrid" :autorowheight="true" :autoheight="true"
                 :width="width" :theme="'material-green'" :selectionmode="'singlerow'" :ready="ready"
                 :pageable="true" :sortable="true" :filterable="true" :showfilterrow="true" :columnsresize="true"
                 :source="dataAdapter" :columns="columns" @rowclick="myGridOnRowClick($event)"
                 @contextmenu="myGridOnContextMenu()"
                 @rowselect="bankinGridOnRowSelect($event)"
        />
        <JqxMenu ref="myMenu" @itemclick="myMenuOnItemClick($event)"
                 :width="200" :height="58" :mode="'popup'" :autoOpenPopup="false">
          <ul>
            <li>Edit</li>
            <li>Batal</li>
          </ul>
        </JqxMenu>
        <br/>
        <h3>Detail Bank Masuk</h3>
        <JqxGrid ref="detailGrid"
                 :width="width" :height="250"
                 :keyboardnavigation="false" :columns="columns3" :showstatusbar="true" :showaggregates="true" :columnsresize="true">
        </JqxGrid>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";
import JqxMenu from "jqwidgets-scripts/jqwidgets-vue/vue_jqxmenu.vue";

export default {
  components: {
    JqxGrid,
    JqxMenu
  },
  data: function () {
    return {
      dataAdapter: new jqx.dataAdapter(this.source, {
        formatData: function (data) {
          return JSON.stringify(data);
        },
        beforeSend: function (jqxhr, settings) {
          settings.xhrFields = {
            withCredentials: true
          };
          jqxhr.setRequestHeader("X-XSRF-TOKEN", window.$cookies.get('XSRF-TOKEN'))
        }
      }),
      width: "100%",
      columns: [
        { text: 'Tgl', datafield: 'tanggal', filtertype: 'range', width: '15%', cellsformat: 'dd-MM-yyyy' },
        { text: 'No Trans', datafield: 'trans_no', width: '20%' },
        { text: 'Jumlah', datafield: 'nilai', width: '20%', cellsformat: 'D' },
        { text: 'Keterangan', datafield: 'keterangan', width: '45%' }
      ],
      columns3: [
        { text: 'Kode Perk', datafield: 'kode_perk', width: '20%' },
        { text: 'Nama Perk', datafield: 'nama_perk', width: '30%' },
        { text: 'Nilai', datafield: 'nilai', width: '20%', cellsrenderer: (index, datafield, value, defaultvalue, column, rowdata) => {
            let total = rowdata.nilai;
            return '<div style="margin: 8px;" class="jqx-left-align">' + this.dataAdapter.formatNumber(total, 'd2') + '</div>';
          }
        },
        { text: 'Keterangan', datafield: 'keterangan', width: '30%' }
      ],
      selectrow: 0
    }
  },
  methods: {
    ready: function () {
      this.$refs.myGrid.selectrow(0);
      this.$refs.myGrid.focus();
    },
    inputTrans: function () {
      this.$router.push({ name: 'bankininput' });
    },
    editTrans: function (data) {
      this.$router.push({ name: 'bankinedit', params: { ref: data.id } });
    },
    myGridOnContextMenu: function () {
      return false;
    },
    bankinGridOnRowSelect: function (event) {
      let details = (event.args.row && event.args.row.details) ? event.args.row.details : [];
      let dataSource2 = {
        datafields: [
          { name: 'id', type: 'number' },
          { name: 'kode_perk', type: 'string' },
          { name: 'nama_perk', type: 'string' },
          { name: 'nilai', type: 'number' },
          { name: 'keterangan', type: 'string' }
        ],
        datatype: 'array',
        localdata: details,
        id: 'id'
      }
      let adapter2 = new jqx.dataAdapter(dataSource2);
      this.$refs.detailGrid.source = adapter2;
    },
    myGridOnRowClick: function (event) {
      if (event.args.rightclick) {
        this.$refs.myGrid.selectrow(event.args.rowindex);
        let scrollTop = window.scrollY;
        let scrollLeft = window.scrollX;
        this.$refs.myMenu.open(parseInt(event.args.originalEvent.clientX) + 5 + scrollLeft, parseInt(event.args.originalEvent.clientY) + 5 + scrollTop);
        return false;
      }
    },
    myMenuOnItemClick: function (event) {
      let args = event.args;
      let rowindex = this.$refs.myGrid.getselectedrowindex();
      let rowid = this.$refs.myGrid.getrowid(rowindex);
      let data = this.$refs.myGrid.getrowdatabyid(rowid);
      if (args.innerHTML == 'Edit') {
        this.editTrans(data);
      } else if (args.innerHTML == 'Batal') {
        if (confirm("Anda yakin akan membatalkan transaksi ini...?")) {
          this.$http.delete('/api/bankin/' + data.id).then(() => {
            this.$refs.myGrid.deleterow(rowid);
            this.$vs.notify({ title: 'BERHASIL..', text: 'Data berhasil dihapus..', color: 'success' })
          }).catch(() => {
            this.$vs.notify({ title: 'GAGAL..', text: 'Gagal hapus data..', color: 'danger' })
          })
        }
      }
    }
  },
  mounted: function () {
    document.addEventListener('contextmenu', event => event.preventDefault());
  },
  beforeCreate: function () {
    this.source = {
      datafields: [
        { name: 'tanggal', type: 'date' },
        { name: 'nilai', type: 'number' },
        { name: 'keterangan', type: 'string' },
        { name: 'trans_no', type: 'string' },
        { name: 'details', type: 'array' },
        { name: 'id', type: 'number' }
      ],
      datatype: 'json',
      id: 'id',
      url: this.$urlbackend + '/api/bankin',
      type: 'get',
      deleterow: function (rowid, commit) {
        commit(true);
      }
    }
  }
}
</script>

<style src='@/assets/styles/jqwidgets/jqx.base.css'></style>
